var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ring-loader", {
    staticClass: "loader-centerscreen",
    attrs: {
      loading: _vm.loading,
      color: _vm.spinnerStyle.spinnerColor,
      size: _vm.spinnerStyle.spinnerSize,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }